"use client";

import { c as _c } from "react/compiler-runtime";
import { MenuOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Divider, Dropdown, Space } from "antd";
import { Link, usePathname } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import React from "react";
import styles from "./Header.module.sass";
export interface IPropsHeader {}
export const HeaderMenu: React.FunctionComponent<IPropsHeader> = () => {
  const $ = _c(80);
  const t = useTranslations("nav");
  let t0;
  if ($[0] !== t) {
    t0 = t("home");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <br />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("homeSubtitle");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t2) {
    t3 = <>{t0}{t1}{t2}</>;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = {
      label: t3,
      url: "/" as const
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("portfolio");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("portfolioSubtitle");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <>{t5}{t6}{t7}</>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = {
      label: t8,
      url: "/portfolio" as const
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("guestbook");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <br />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("guestbookSubtitle");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <>{t10}{t11}{t12}</>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = {
      label: t13,
      url: "/guestbook" as const
    };
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("friendlyLink");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <br />;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = t("friendlyLinkSubtitle");
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t17) {
    t18 = <>{t15}{t16}{t17}</>;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t18) {
    t19 = {
      label: t18,
      url: "/friendly-link" as const
    };
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t) {
    t20 = t("resume");
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <br />;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t) {
    t22 = t("resumeSubtitle");
    $[43] = t;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t20 || $[46] !== t22) {
    t23 = <>{t20}{t21}{t22}</>;
    $[45] = t20;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t23) {
    t24 = {
      label: t23,
      url: "/resume" as const
    };
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t) {
    t25 = t("statistic");
    $[50] = t;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <br />;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t) {
    t27 = t("statisticSubtitle");
    $[53] = t;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t25 || $[56] !== t27) {
    t28 = <>{t25}{t26}{t27}</>;
    $[55] = t25;
    $[56] = t27;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t28) {
    t29 = {
      label: t28,
      url: "/statistic" as const
    };
    $[58] = t28;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== t) {
    t30 = t("calendar");
    $[60] = t;
    $[61] = t30;
  } else {
    t30 = $[61];
  }
  let t31;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <br />;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t) {
    t32 = t("calendarSubtitle");
    $[63] = t;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t30 || $[66] !== t32) {
    t33 = <>{t30}{t31}{t32}</>;
    $[65] = t30;
    $[66] = t32;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  let t34;
  if ($[68] !== t33) {
    t34 = {
      label: t33,
      url: "/calendar" as const
    };
    $[68] = t33;
    $[69] = t34;
  } else {
    t34 = $[69];
  }
  let t35;
  if ($[70] !== t14 || $[71] !== t19 || $[72] !== t24 || $[73] !== t29 || $[74] !== t34 || $[75] !== t4 || $[76] !== t9) {
    t35 = [t4, t9, t14, t19, t24, t29, t34];
    $[70] = t14;
    $[71] = t19;
    $[72] = t24;
    $[73] = t29;
    $[74] = t34;
    $[75] = t4;
    $[76] = t9;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  const items = t35;
  let t36;
  if ($[78] !== items) {
    t36 = <><HeaderMenuDesktop items={items} data-sentry-element="HeaderMenuDesktop" data-sentry-source-file="HeaderMenu.tsx" /><HeaderMenuMobile items={items} data-sentry-element="HeaderMenuMobile" data-sentry-source-file="HeaderMenu.tsx" /></>;
    $[78] = items;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  return t36;
};
type MenuItem = {
  label: React.ReactNode;
  url: string;
};
const HeaderMenuDesktop: React.FunctionComponent<{
  items: MenuItem[];
}> = t0 => {
  const $ = _c(8);
  const {
    items
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Divider orientation="vertical" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== items || $[2] !== pathname) {
    let t3;
    if ($[4] !== pathname) {
      t3 = item => {
        const is_current = item.url === "/" ? pathname === "/" : pathname?.startsWith(item.url);
        return <Link key={item.url} href={item.url} className={styles.menu_item} style={{
          fontWeight: is_current ? "700" : "400",
          textDecoration: is_current ? "underline" : ""
        }}>{item.label}</Link>;
      };
      $[4] = pathname;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = items.map(t3);
    $[1] = items;
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Space align="center" className={styles.menu_desktop} separator={t1} data-sentry-element="Space" data-sentry-component="HeaderMenuDesktop" data-sentry-source-file="HeaderMenu.tsx">{t2}</Space>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const HeaderMenuMobile: React.FunctionComponent<{
  items: MenuItem[];
}> = t0 => {
  const $ = _c(14);
  const {
    items
  } = t0;
  const t = useTranslations("nav");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      components: {
        Dropdown: {
          paddingBlock: 8,
          fontSize: 16
        }
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== items) {
    t2 = items.map(_temp);
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      items: t2
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["click"];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MenuOutlined aria-hidden={true} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t("menu");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <Button icon={t5} size="large" aria-label={t6} aria-haspopup="menu" data-sentry-element="Button" data-sentry-source-file="HeaderMenu.tsx" />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t7) {
    t8 = <ConfigProvider theme={t1} data-sentry-element="ConfigProvider" data-sentry-component="HeaderMenuMobile" data-sentry-source-file="HeaderMenu.tsx"><div className={styles.menu_mobile}><Dropdown menu={t3} trigger={t4} data-sentry-element="Dropdown" data-sentry-source-file="HeaderMenu.tsx">{t7}</Dropdown></div></ConfigProvider>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
function _temp(item) {
  return {
    key: item.url,
    label: <Link key={item.url} href={item.url} className={styles.menu_item}>{item.label}</Link>
  };
}